import dataLayer from "./index";
import { formsProps } from "./types";

const forms: formsProps = {
  "DS-5504": "e0dfa980-f697-5b56-8ca3-2c91479e954b",
  "DS-64": "559d8b00-8315-50b3-9db3-0e363b8d9506",
  "DS-11": "59ce1679-1249-5ead-8c10-c0ee9731cfe8",
  "DS-82": "8684cd82-3522-514e-a646-2e164bce07b2",
};

export const sendViewItemListEvent = (formNames: string[], price: number) => {
  dataLayer.push("view_item_list", {
    ecommerce: {
      currency: "USD",
      view_item_list: {
        items: formNames.map((formName) => ({
          item_id: forms[formName],
          item_name: formName,
          item_category: "Form",
          price: price,
          quantity: 1,
        })),
      },
    },
  });
};
